import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.BankAccountsPage.ConnectBankAccountPopup.ConnectBankAccountPopupContent', {
    bankingAppMustBeConnected: 'To send payments in ApprovalMax, you must connect a bank account. {learnMore}',
    learnMore: 'Learn more',
    next: 'Next',
    notTheBankAccountHolder: 'Not the account holder?',
    pleaseContactAdmin: 'Contact your Administrator or Account owner',
    searchBank: 'Search Bank...',
    searchCountry: 'Search Country...',
    title: 'Connect a bank account',
});
